import { render, staticRenderFns } from "./RiskControlMeasures.vue?vue&type=template&id=1a22beaf"
import script from "./RiskControlMeasures.vue?vue&type=script&lang=js"
export * from "./RiskControlMeasures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports